export const REFERRAL_CODE_KEY = "referralCode";

// Dependency-free so the lean web component bundles can use it too. Storage access
// is guarded: a SecurityError from blocked storage must never abort page load or a
// signup submit.
export const persistReferralCodeFromUrl = (): string | null => {
  const fromUrl = new URLSearchParams(window.location.search).get(REFERRAL_CODE_KEY);
  if (fromUrl) {
    try {
      sessionStorage.setItem(REFERRAL_CODE_KEY, fromUrl);
    } catch {
      // ignore — the code is still returned to the caller
    }
  }
  return fromUrl;
};

// URL takes precedence (first visit) with a sessionStorage fallback for navigations
// that dropped the query string before submit.
export const getStoredReferralCode = (): string | null => {
  const fromUrl = persistReferralCodeFromUrl();
  if (fromUrl) return fromUrl;
  try {
    return sessionStorage.getItem(REFERRAL_CODE_KEY);
  } catch {
    return null;
  }
};
